module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "order-review-content"
  }, [_c('span', {
    staticClass: "order-reviewpatient-title"
  }, [_vm._v("Patient")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "order-reviewpatient-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.patFirstName) + " " + _vm._s(_vm.OrderReturn.patLastName))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "order-review-border"
  }, [_c('div', {
    staticClass: "order-info-content"
  }, [_c('span', {
    staticClass: "order-reviewpatient-title"
  }, [_vm._v("Order Information")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Lens Design:")]), _vm._v(" " + _vm._s(_vm.OrderReturn.lensDesignDescription))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Lens Material:")]), _vm._v(" " + _vm._s(_vm.OrderReturn.lensMaterialDescription))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table-rx"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "order-review-label table-rx-td-title"
  }, [_vm._v("RE/OD")]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reSph))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reCyl))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reAxis))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reAdd))]), _vm._v(" "), (!_vm.OrderReturn.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reDistPD))]) : _c('td', {
    staticClass: "order-review-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.OrderReturn.distancePD))])]), _vm._v(" "), (!_vm.OrderReturn.isOnly1NearPD) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reNearPD))]) : _c('td', {
    staticClass: "order-review-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.OrderReturn.nearPD))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-review-label table-rx-td-title"
  }, [_vm._v("LE/OS")]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leSph))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leCyl))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leAxis))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leAdd))]), _vm._v(" "), (!_vm.OrderReturn.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leDistPD))]) : _vm._e(), _vm._v(" "), (!_vm.OrderReturn.isOnly1NearPD) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leNearPD))]) : _vm._e()]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-review-label table-rx-td-title"
  }, [_vm._v("RE/OD")]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reSegHeight))]), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reocHeight))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reHorizontalPrismValue))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reHorizontalPrismDirection))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reVerticalPrismValue))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reVerticalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-review-label table-rx-td-title"
  }, [_vm._v("LE/OS")]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leSegHeight))]), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leocHeight))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leHorizontalPrismValue))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leHorizontalPrismDirection))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leVerticalPrismValue))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leVerticalPrismDirection))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Lens Treatment:")]), _vm._v(" "), _vm._l((_vm.OrderReturn.lensTreatmentDescription), function(tr) {
    return _c('div', {
      staticClass: "order-review-description"
    }, [_vm._v(_vm._s(tr) + " ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Special Instructions:")]), _vm._v("\n                          " + _vm._s(_vm.OrderReturn.specialInstructions1) + "\n  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Frame:")]), _vm._v(" "), _c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.frameManufacturer) + ", " + _vm._s(_vm.OrderReturn.frameBrand) + " " + _vm._s(_vm.OrderReturn.frameModel) + ", " + _vm._s(_vm.OrderReturn.frameEyeSize) + "-" + _vm._s(_vm.OrderReturn.frameTempleLength) + ", " + _vm._s(_vm.OrderReturn.frameColor))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Job Type:")]), _vm._v(" "), _c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.jobTypeDescription))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-7 col-sm-12 col-xs-12"
  }, [_c('div', [_c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.shippingFullName))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.shippingAddressLineOne))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.shippingAddressLineTwo))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.shippingCity) + ", " + _vm._s(_vm.OrderReturn.shippingState) + " " + _vm._s(_vm.OrderReturn.shippingPostcode))])])])])]), _vm._v(" "), (_vm.MasterAccountType != 'master' && ((_vm.Account.isStandardOrderServiceFee && _vm.OrderReturn.jobType != 'LSF') || (_vm.OrderReturn.jobType == 'LSF' && _vm.Account.isFrameLensServiceFee))) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    staticClass: "order-review-description left"
  }, [_vm._v("Service Fee")]), _vm._v(" "), _c('span', {
    staticClass: "order-review-description right"
  }, [_vm._v("$" + _vm._s(_vm.Account.serviceFeeAmount))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('span', {
    staticClass: "order-review-description right"
  }, [_vm._v("$" + _vm._s(_vm.Account.serviceFeeAmount))])])])]), _vm._v(" "), (_vm.Voucher.Payment) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing top"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("*The voucher provided covers the payment amount for this order.")])]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-10 offset-lg-1"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Sphere")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Cyl")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Axis")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Addition")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Dist. PD")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Near PD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Seg Height")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("OC Height")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("H Prism")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Base")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("V Prism")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Base")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-5 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Shipping Address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Order Summary:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8"
  }, [_c('label', {
    staticClass: "order-review-label right"
  }, [_vm._v("Total:")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-251a79f9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-251a79f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderComponent/OrderReview.vue
// module id = 472
// module chunks = 3